import { SharedModule } from '../../../shared/shared.module';
import { SeekersListComponent } from './seekers-list.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions'

@NgModule({
  imports: [NgbModule, SharedModule, BsDatepickerModule, DataTableModule],
  declarations: [SeekersListComponent],
  exports: [SeekersListComponent]
})
export class SeekersListModule {}
